// import submitSchema from './submitSchema';

const yup = require('yup');
import programSchema from '../program';
import universityEntranceQualificationSchema from './studies/universityEntranceQualification';
import academicSchema from './studies/academic';
import previousStudiesSchema from './studies/previousStudies';
import jobSchema from './studies/job';

/**
 *
 * @param {[]} values
 * @param {?Program} currentProgram
 * @param {Program[]} programs
 * @param {Country[]} countries
 * @param {Location[]} locations
 * @returns {Object}
 */
export default ({currentProgram, programs}) => {

  function programRequiresJobStep(job = {}) {
    return ((job.experienceRequired || job.educationRequired || job.bonusCreditsType) && true) ||
      false;
  }

  function programRequiresAcademicStep(qualification = {}) {
    return (qualification.academicQualificationRequired && true) ||
      false;
  }

  return yup.object().shape({
    universityEntranceQualification: universityEntranceQualificationSchema({currentProgram}).required(),
    academic: (programRequiresAcademicStep(currentProgram.qualification) && academicSchema({currentProgram}).required()) ||
      undefined,
    previousStudies: previousStudiesSchema({currentProgram}).required(),
    job:
      (programRequiresJobStep(currentProgram.job) && jobSchema(currentProgram).required()) ||
      undefined,
  });
}